import React from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "../components/DashboardLayout";
import { useAssistant } from "../components/support/AssistantWorkspace";

export default function Onboarding() {
  const assistant = useAssistant();
  const progress = assistant?.context?.setup_progress;
  return (
    <DashboardLayout title="Configuración inicial">
      <section className="bo-scope aimp-onboarding">
        <div className="bo-section-head">
          <div>
            <span className="bo-eyebrow">TU CLÍNICA EN AIMP</span>
            <h2>Continúa donde te quedaste</h2>
            <p>Configura cada paso con ayuda del chat. Tu conversación sigue disponible al cambiar de página.</p>
          </div>
          <button type="button" className="bo-primary" onClick={assistant?.openAssistant}>Abrir asistente</button>
        </div>
        {assistant?.error && <p className="bo-error" role="alert">{assistant.error}</p>}
        {!progress && <p role="status">{assistant?.error ? "No se pudo comprobar el estado de la clínica." : "Consultando la configuración guardada…"}</p>}
        {progress && <>
          <div className="bo-toolbar">
            <strong>{progress.configured_count} de {progress.total} pasos con configuración guardada</strong>
            <button type="button" onClick={assistant.refreshContext} disabled={assistant.busy}>Actualizar estado</button>
          </div>
          <div className="aimp-onboarding-progress" role="progressbar" aria-label="Pasos con configuración guardada"
            aria-valuenow={progress.configured_count} aria-valuemin={0} aria-valuemax={progress.total}>
            <span style={{ width: `${progress.configured_count / progress.total * 100}%` }} />
          </div>
          <div className="aimp-setup-list">
            {progress.steps.map((step, index) => <article key={step.key} className="aimp-setup-step">
              <span aria-hidden="true">{index + 1}</span>
              <div><h3>{step.label}</h3><span className="bo-pill">{step.status === "configured" ? "Guardado · revisar" : "Pendiente"}</span><p>{step.detail}</p></div>
              <Link to={step.href}>{step.status === "configured" ? "Revisar" : "Configurar"}</Link>
            </article>)}
          </div>
          <p className="bo-notice">{progress.notice}</p>
        </>}
        <div className="bo-actions">
          {!progress && <button type="button" onClick={assistant?.refreshContext}>Volver a comprobar</button>}
          <Link to="/dashboard">Ir al dashboard</Link>
        </div>
      </section>
    </DashboardLayout>
  );
}
